(() => {
  ['#NavDrawer', '#CartDrawer', '.site-header__search-container'].forEach(selector => {
    const overlay = document.querySelector(selector);
    if (overlay && overlay.parentElement !== document.body) document.body.append(overlay);
  });

  const storageKey = 'hellsinki:wishlist:v1';
  const dialog = document.getElementById('HellsinkiWishlist');
  const body = dialog?.querySelector('[data-wishlist-items]');
  const closeButton = dialog?.querySelector('.hellsinki-wishlist__close');
  let returnFocus = null;
  let closeTimer = null;

  if (!dialog || !body) return;

  const readItems = () => {
    try {
      const items = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(items) ? items.filter(item => item && item.id && typeof item.url === 'string' && item.url.startsWith('/') && !item.url.startsWith('//')).slice(0, 60) : [];
    } catch {
      return [];
    }
  };

  const saveItems = items => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(items));
    } catch {
      return;
    }
  };

  const syncButtons = () => {
    const saved = new Set(readItems().map(item => String(item.id)));
    document.querySelectorAll('.hellsinki-wishlist-save').forEach(button => {
      const isSaved = saved.has(button.dataset.wishlistId);
      button.setAttribute('aria-pressed', String(isSaved));
      button.setAttribute('aria-label', `${isSaved ? 'Remover' : 'Salvar'} ${button.dataset.wishlistTitle || 'produto'} ${isSaved ? 'dos' : 'nos'} favoritos`);
    });
  };

  const render = () => {
    const items = readItems();
    body.replaceChildren();

    if (!items.length) {
      const empty = document.createElement('div');
      empty.className = 'hellsinki-wishlist__empty';
      const title = document.createElement('h3');
      title.textContent = 'Sua lista está vazia';
      const text = document.createElement('p');
      text.textContent = 'Toque no coração de uma peça para salvá-la aqui.';
      const link = document.createElement('a');
      link.href = '/collections/all';
      link.textContent = 'Ver produtos';
      empty.append(title, text, link);
      body.append(empty);
      return;
    }

    const list = document.createElement('div');
    list.className = 'hellsinki-wishlist__list';
    items.forEach(item => {
      const card = document.createElement('div');
      card.className = 'hellsinki-wishlist__item';
      if (item.image && (item.image.startsWith('https://') || item.image.startsWith('/'))) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title || '';
        image.loading = 'lazy';
        card.append(image);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'hellsinki-wishlist__image-placeholder';
        card.append(placeholder);
      }
      const details = document.createElement('div');
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title || 'Ver produto';
      details.append(link);
      if (item.price) {
        const price = document.createElement('span');
        price.textContent = item.price;
        details.append(price);
      }
      card.append(details);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'hellsinki-wishlist__remove';
      remove.dataset.wishlistRemove = String(item.id);
      remove.setAttribute('aria-label', `Remover ${item.title || 'produto'} dos favoritos`);
      remove.textContent = '×';
      card.append(remove);
      list.append(card);
    });
    body.append(list);
  };

  const close = () => {
    if (dialog.hidden || !dialog.classList.contains('is-open')) return;
    dialog.classList.remove('is-open');
    document.body.classList.remove('hellsinki-wishlist-active');
    document.querySelectorAll('.hellsinki-wishlist-open').forEach(button => button.setAttribute('aria-expanded', 'false'));
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      if (!dialog.classList.contains('is-open')) dialog.hidden = true;
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 340);
    returnFocus?.focus();
  };

  const open = source => {
    clearTimeout(closeTimer);
    document.querySelector('#NavDrawer.drawer--is-open .js-drawer-close')?.click();
    document.querySelector('#CartDrawer.drawer--is-open .js-drawer-close')?.click();
    if (document.querySelector('.site-header__search-container.is-active')) {
      document.dispatchEvent(new CustomEvent('predictive-search:close'));
    }
    returnFocus = source;
    render();
    dialog.hidden = false;
    requestAnimationFrame(() => dialog.classList.add('is-open'));
    document.body.classList.add('hellsinki-wishlist-active');
    document.querySelectorAll('.hellsinki-wishlist-open').forEach(button => button.setAttribute('aria-expanded', 'true'));
    closeButton?.focus();
  };

  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const saveButton = target.closest('.hellsinki-wishlist-save');
    if (saveButton) {
      event.preventDefault();
      event.stopPropagation();
      const id = saveButton.dataset.wishlistId;
      if (!id) return;
      const items = readItems();
      const index = items.findIndex(item => String(item.id) === id);
      if (index >= 0) {
        items.splice(index, 1);
      } else {
        items.unshift({
          id,
          url: saveButton.dataset.wishlistUrl || '',
          title: saveButton.dataset.wishlistTitle || '',
          image: saveButton.dataset.wishlistImage || '',
          price: saveButton.dataset.wishlistPrice || ''
        });
      }
      saveItems(items);
      syncButtons();
      if (!dialog.hidden) render();
      return;
    }

    const openButton = target.closest('.hellsinki-wishlist-open');
    if (openButton) {
      event.preventDefault();
      open(openButton);
      return;
    }

    const removeButton = target.closest('[data-wishlist-remove]');
    if (removeButton) {
      saveItems(readItems().filter(item => String(item.id) !== removeButton.dataset.wishlistRemove));
      render();
      syncButtons();
      return;
    }

    if (target.closest('[data-wishlist-close]')) {
      close();
      return;
    }

    if (!dialog.hidden && target.closest('.js-drawer-open-cart, .js-drawer-open-nav, .js-search-header')) close();
  });

  document.addEventListener('keydown', event => {
    if (dialog.hidden || !dialog.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button, a[href]')].filter(element => element.getClientRects().length);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('drawerOpen', close);
  window.addEventListener('storage', event => {
    if (event.key === storageKey) {
      syncButtons();
      if (!dialog.hidden) render();
    }
  });

  const searchContainer = document.querySelector('.site-header__search-container');
  searchContainer?.addEventListener('click', event => {
    if (event.target === searchContainer) {
      document.dispatchEvent(new CustomEvent('predictive-search:close'));
    }
  });

  syncButtons();
})();
